import React from "react";
import { Upload, FileText } from "lucide-react";

interface CsvImportPromoProps {
  onImportClick?: () => void;
}

export const CsvImportPromo: React.FC<CsvImportPromoProps> = ({
  onImportClick,
}) => {
  return (
    <>
      {/* OR Divider */}
      <div className="relative flex items-center">
        <div className="flex-grow border-t border-slate-300" />
        <span className="flex-shrink text-[14px] px-2 font-medium text-slate-600 tracking-wider">
          OR
        </span>
        <div className="flex-grow border-t border-slate-300" />
      </div>

      {/* CSV Import */}
      <div className="space-y-3">
        <div className="border border-dashed border-[#E2E8F0] rounded-[12px] p-5 flex items-center justify-between bg-[#F8F9FF4D]">
          <div className="flex items-center gap-3.5">
            <div className="w-10 h-10 rounded-full bg-[#A655F8]/10 flex items-center justify-center text-[#A655F8] shrink-0">
              <Upload className="w-5 h-5 stroke-[1.8]" />
            </div>
            <div>
              <h5 className="text-[14px] font-semibold text-slate-800">
                Import via CSV
              </h5>
              <p className="text-[14px] text-slate-500">
                Upload a CSV file with Instagram handles
              </p>
            </div>
          </div>
          <button
            type="button"
            onClick={onImportClick}
            className="h-9 px-4 border border-[#A655F8] text-[#A655F8] text-[14px] font-medium rounded-[8px] bg-white focus:outline-none"
          >
            Upload CSV
          </button>
        </div>

        <div className="flex items-center justify-between text-[12px] text-slate-700 px-0.5">
          <div className="flex items-center gap-1.5">
            <FileText className="w-4 h-4 text-slate-700 stroke-[1.8]" />
            <span className="text-[12px]">CSV format: one handle per row</span>
          </div>
          <span>Max file size: 5MB</span>
        </div>
      </div>
    </>
  );
};
